import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import type { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import AddressOverview from '../../../../components/AddressOverview';

import './style.scss';

const AddressesAccountPage: React.FC = () => {
  const { t } = useTranslation();
  const uid = useSelector<ImmutableRootState<number>, number>((state) => state.getIn(['login', 'uid'], 0));
  const userProfile = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['user', uid, 'profile'], undefined));

  return (
    <div className="AddressesAccountPage">
      {userProfile && (
        <AddressOverview />
      )}
    </div>
  );
};

export default AddressesAccountPage;
